import Step01 from "./01Step";
import Step02 from "./02Step";
import Step03 from "./03Step";

export const formSteps = {
  1: Step01,
  2: Step02,
  3: Step03,
};
